import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { formatUtcDate } from "../../utils/utcDate";
import customerApi from "../../services/customerapi";


const CustomerViewModal = ({ invModal, customerId, change }) => {
    const [customerModal, setCustomerModal] = useState(invModal);
    const [customerDetails, setCustomerDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const handleCustomerClose = () => {
        setCustomerModal(false);
        change();
    };
    useEffect(() => {
        setIsLoading(true);
        const fetchDetail = async () => {
            try {
                const data = await customerApi.getCustomerDetails({customerId});
                if (data) {
                    setCustomerDetails({...data.data});
                    setIsLoading(false);
                }
            } catch (e) {
                console.error("Failed to fetch branch:", e);
            }
        };
        fetchDetail();
    }, []);
    const indCurrency = "₹";
    // console.log(customerDetails,'customerDetails');
    return (
        <div>
            <Modal show={customerModal} onHide={handleCustomerClose} size="lg" centered>
                {isLoading ? (
                    "Customer detail is loading...."
                ) : (
                    <>
                        <div id="customerCapture">
                            <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
                                <div className="w-100">
                                    <h4 className="fw-bold my-2">
                                        {customerDetails.customer.name}
                                    </h4>

                                </div>
                                <div className="text-end ms-4">
                                    <h6 className="fw-bold text-secondary mb-1">
                                        {customerDetails.customer.mobile}
                                    </h6>
                                    <h6 className="fw-bold text-secondary mb-1">
                                        {customerDetails.customer.email}
                                    </h6>
                                </div>
                            </div>
                            <div className="p-4">
                                <Table className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Existing Status</th>
                                            <th>New Status</th>
                                            <th className="text-end">Notes</th>
                                            <th className="text-end">Date (UTC)</th>
                                            <th className="text-end">Done By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerDetails.customerLog.result.map((item, i) => {
                                            return (
                                                <tr id={i} key={i}>
                                                    <td>
                                                        {customerDetails.statusArr[item.old_status] || ''}
                                                    </td>
                                                    <td style={{ width: "70px" }}> {customerDetails.statusArr[item.new_status] || ''} </td>
                                                    <td className="text-end" style={{ width: "100px" }}>
                                                        {item.reason ?? ''}
                                                    </td>
                                                    <td className="text-end" >
                                                        {formatUtcDate(item.updated_at)}
                                                    </td>
                                                    <td className="text-end" style={{ width: "100px" }}>
                                                        {item.admin.name ?? ''}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                               
                            </div>
                        </div>
                        <div className="pb-4 px-4">
                            <Row>
                                <Col md={6}>
                                    <Button
                                        variant="danger"
                                        className="d-block w-100"
                                        onClick={handleCustomerClose}
                                    >
                                        Close
                                    </Button>
                                </Col>

                            </Row>
                        </div>
                    </>
                )}
            </Modal>
            <hr className="mt-4 mb-3" />
        </div>
    );
};

export default CustomerViewModal;